import { tv, VariantProps } from 'tailwind-variants';

const fileDownloadButtonVariants = tv({
  slots: {
    container: 'flex flex-col gap-4 max-w-full animate-journey-slide-up',
    button:
      'group flex items-center gap-3 px-3 py-2.5 bg-[#fbfaf9] hover:bg-[#f4f1ed] outline-none border-1 border-solid border-gray-200 hover:border-gray-300 rounded-lg transition-all duration-200 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-blue-500/20 max-w-full',
    fileIcon: 'w-5 h-5 flex-shrink-0 transition-transform duration-200 group-hover:scale-110',
    fileInfo: 'flex flex-col items-start flex-1 min-w-0 overflow-hidden',
    fileName: 'text-sm group-hover:font-semibold text-gray-900 truncate w-full',
    fileSize: 'text-xs text-gray-500 font-medium text-left truncate w-full',
    downloadIcon: 'w-4 h-4 text-gray-500 flex-shrink-0 transition-colors duration-200 group-hover:text-gray-900',
    spinner: 'animate-spin h-4 w-4 border-2 border-gray-400 border-t-blue-600 rounded-full flex-shrink-0',
    errorContainer: 'flex items-center gap-1.5 text-xs text-red-600 bg-red-50 px-2 py-1 rounded-md',
    errorIcon: 'w-3.5 h-3.5 flex-shrink-0',
  },
  variants: {
    fileType: {
      excel: {
        fileIcon: 'text-emerald-600',
        button: 'hover:bg-emerald-50/50',
      },
      csv: {
        fileIcon: 'text-green-600',
        button: 'hover:bg-green-50/50',
      },
      pdf: {
        fileIcon: 'text-rose-600',
        button: 'hover:bg-rose-50/50',
      },
      image: {
        fileIcon: 'text-sky-600',
        button: 'hover:bg-sky-50/50',
      },
      text: {
        fileIcon: 'text-slate-600',
        button: 'hover:bg-slate-50/50',
      },
      presentation: {
        fileIcon: 'text-amber-600',
        button: 'hover:bg-amber-50/50',
      },
      json: {
        fileIcon: 'text-violet-600',
        button: 'hover:bg-violet-50/50',
      },
      default: {
        fileIcon: 'text-gray-600',
        button: 'hover:bg-gray-50',
      },
    },
  },
  defaultVariants: {
    fileType: 'default',
  },
});

type FileDownloadButtonVariant = VariantProps<typeof fileDownloadButtonVariants>['fileType'];

export { fileDownloadButtonVariants };
export type { FileDownloadButtonVariant };
